import React from "react";
import { StyledSnackbar } from "../../components/common/AppSnackbar";

function getSaveSnackbarFeedback(failedSave, failedUploads) {
  const hasFailedUploads =
    failedUploads && Object.keys(failedUploads).length > 0;

  if (failedSave && hasFailedUploads) {
    return {
      severity: "error",
      message:
        "Form data and uploaded files could not be saved. Please try again.",
    };
  }
  if (failedSave) {
    return {
      severity: "error",
      message: "Form data could not be saved. Please try again.",
    };
  }
  if (hasFailedUploads) {
    return {
      severity: "error",
      message:
        "Uploaded file(s) could not be saved. Please check and re-upload, then try again.",
    };
  }
  return {
    severity: "success",
    message: "Form data saved",
  };
}

export default function SaveSnackbar({ formFailures, open, close }) {
  const { failedUploads, failedSave } = formFailures;
  const { severity, message } = getSaveSnackbarFeedback(
    failedSave,
    failedUploads
  );

  return (
    <StyledSnackbar
      open={open}
      message={message}
      severity={severity}
      onClose={close}
    />
  );
}
